// react
import React from "react"
import { connect } from "react-redux"
import DocumentTitle from "react-document-title"
import { browserHistory } from "react-router"
// material-ui
import { Card, CardHeader, CardActions, CardText } from "material-ui/Card"
import FlatButton from "material-ui/FlatButton"
// app
import TextField from "components/common/TextField"
import { resetPassword } from "actions/user/actions.js"


class ForgotPassword extends React.Component {
    constructor(props) {
        super()

        this.state = {
            email: ""
        }

        this.onEmailChange = email => this.setState({ email })
        
        this.onKeyDown = this.onKeyDown.bind(this)
        this.onOk = this.onOk.bind(this)
    }
    
    componentWillMount() {
        if (this.props.isLoggedIn) browserHistory.replace("/")
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isLoggedIn) browserHistory.replace("/")

    }

    onKeyDown(e) {
        if (e.keyCode !== 13) return
        if (this.state.email === "") return
        this.onOk()
    }

    onOk() {
        const { email } = this.state
        if (email === "") return
        this.props.resetPassword(email)
    }

    render() {
        if (this.props.isLoggedIn) return null
        if (this.props.fetching) return null

        return (
            <DocumentTitle title="AviationNetwork | Reset Password">
                <div className="page">
                    <div className="row">
                        <div className="col-xs-6">
                            <Card>
                                <CardHeader
                                    title="Reset Password"
                                    style={{ paddingBottom: 0 }}
                                />
                                <CardText>
                                    <p>
                                        { this.props.reset ? 
                                            "We have sent you an email with instructions how to reset your password."
                                            :
                                            "Please enter your email address to reset your password."
                                        }
                                    </p>
                                    { this.props.reset ? 
                                        null
                                        :
                                        <TextField
                                            label="Email"
                                            onChange={ this.onEmailChange }
                                            onKeyDown={ this.onKeyDown }
                                            autoFocus={ true }
                                        />
                                    }
                                </CardText>
                                <CardActions>
                                    { this.props.reset ? 
                                        null
                                        :
                                        <FlatButton
                                            label="Reset Password"
                                            primary={ true }
                                            disabled={ this.state.email === "" }
                                            onTouchTap={ this.onOk }
                                        />
                                    }
                                </CardActions>
                            </Card>
                        </div>
                    </div>
                </div>
            </DocumentTitle>
        )
    }
}

function mapStateToProps(state) {
    return {
        isLoggedIn: (state.user.get("id") !== 0),
        fetching: (state.user.get("fetching", false) === true),
        reset: (state.user.get("reset", false) === true)
    }
}

function mapDispatchToProps(dispatch) {
    return {
        resetPassword: email => dispatch(resetPassword(email))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)



/** WEBPACK FOOTER **
 ** ./src/containers/ForgotPassword/forgotpwd.js
 **/